export type ImportedData = {
  browserTitle: string | null;
  canonicalUrl: string | null;
  pageKeywords: string | null;
  pageDescription: string | null;
  pageType: string | null;
  imageUrl: string | null;
  imageWidth: string | null;
  imageHeight: string | null;
  imageType: string | null;
  firstName: string | null;
  lastName: string | null;
  gender: string | null;
  publishedTime: string | null;
  modifiedTime: string | null;
  section: string | null;
  jsonPayload: string | null;
  navigationTitle: string | null;
  siteName: string | null;
};

export enum ImportedDataType {
  SparkleEvent,
  SparkleLocation,
  SparkleProvider,
}
